module.exports = __webpack_public_path__ + "static/media/want-updates-company.08724cb6.png";